export enum VersionActionType {
    GET_LATEST_VERSION = 'GET_LATEST_VERSION',
}
